import React from 'react';
import { useTranslation } from "react-i18next" 
import { Link } from 'react-router-dom';

const FooterHome = () => {
    const {t} = useTranslation(['sidebar']); 
    return (
        <footer className="bg-gray-100 border-t border-gray-300 text-sm"> 
            <nav className="navbar navbar-expand navbar-light bg-white topbar mb-0 static-top shadow">
                <div className="copyright text-left my-auto">
                    <span>{t('Text_Copyright')}</span>
                </div>
                <ul className="navbar-nav ml-auto">
                    <div className="topbar-divider d-none d-sm-block"></div>
                    <Link className="nav-link" to="/terms" > 
                        {t('Text_Terms')}
                    </Link> 
                    <div className="topbar-divider d-none d-sm-block"></div>
                    <Link className="nav-link" to="/privacity" >
                        {t('Text_Privacity')}
                    </Link>  
                </ul>
            </nav> 
        </footer>
    );
};

export default FooterHome;
